(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-pete-autocomplete]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const input = form.querySelector('[name="q"]');
      const panel = form.querySelector('.pete-search-panel');
      const list = form.querySelector('[role="listbox"]');
      const status = form.querySelector('[data-search-status]');
      let timer, controller, request = 0, active = -1;
      const options = () => [...list.querySelectorAll('[role="option"]')];
      const close = () => {
        clearTimeout(timer);
        controller?.abort();
        request++;
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        input.removeAttribute('aria-busy');
        status.textContent = '';
        active = -1;
      };
      const search = async () => {
        const term = input.value.trim();
        if (term.length < 2 || document.activeElement !== input) return close();
        controller?.abort();
        controller = new AbortController();
        const version = ++request;
        input.setAttribute('aria-busy', 'true');
        status.textContent = form.dataset.loading;
        try {
          const url = new URL(form.dataset.endpoint, location.origin);
          url.search = new URLSearchParams({q: term, section_id: 'pete-predictive-search', 'resources[type]': 'product,collection,query', 'resources[limit]': '4', 'resources[limit_scope]': 'each'});
          const response = await fetch(url, {signal: controller.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = html.querySelector('[data-pete-search-results]');
          if (!results) throw new Error('Missing results');
          if (version !== request || input.value.trim() !== term || document.activeElement !== input) return;
          list.replaceChildren(...results.childNodes);
          options().forEach((option, index) => { option.id = `pete-search-option-${index}`; });
          active = -1;
          input.removeAttribute('aria-activedescendant');
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          status.textContent = form.dataset.updated;
        } catch (error) {
          if (error.name !== 'AbortError' && version === request) {
            close();
            status.textContent = form.dataset.failed;
          }
        } finally {
          if (version === request) input.removeAttribute('aria-busy');
        }
      };
      input.addEventListener('input', () => {
        close();
        if (!input.matches(':focus') || input.value.trim().length < 2) return;
        timer = setTimeout(search, 220);
      });
      input.addEventListener('focus', search);
      input.addEventListener('keydown', event => {
        if (event.isComposing) return;
        if (event.key === 'Escape') { close(); return; }
        if (panel.hidden) return;
        const items = options();
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          active = event.key === 'ArrowDown' ? (active + 1) % items.length : (active <= 0 ? items.length - 1 : active - 1);
          items.forEach((item, index) => item.setAttribute('aria-selected', String(index === active)));
          input.setAttribute('aria-activedescendant', items[active].id);
          items[active].scrollIntoView({block: 'nearest'});
        } else if (event.key === 'Enter' && active >= 0) {
          event.preventDefault();
          items[active].click();
        }
      });
      form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) close(); });
      form.addEventListener('submit', close);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
